const texts = {
    "receipt-estimated-refund": {
        EN: "Estimated refund",
        DA: "Estimeret refusion",
        DE: "Geschätzte Rückerstattung",
        NL: "Geschatte terugbetaling",
        FR: "Remboursement estimé",
        IT: "Rimborso stimato",
        ES: "Reembolso estimado",
        PT: "Reembolso estimado",
        FI: "Arvioitu hyvitys",
        SV: "Estimerad återbetalning",
        NO: "Estimert tilbakebetaling",
    },

    "receipt-estimated-resale": {
        EN: "Estimated payout",
        DA: "Estimeret udbetaling",
        DE: "Geschätzte Auszahlung",
        NL: "Geschatte uitbetaling",
        FR: "Paiement estimé",
        IT: "Pagamento stimato",
        ES: "Pago estimado",
        PT: "Pagamento estimado",
        FI: "Arvioitu maksu",
        SV: "Estimerad utbetalning",
        NO: "Estimert utbetaling",
    },

    "receipt-total-amount": {
        EN: "Refund",
        DA: "Refusion",
        DE: "Rückerstattung",
        NL: "Terugbetaling",
        FR: "Remboursement",
        IT: "Rimborso",
        ES: "Reembolso",
        PT: "Reembolso",
        FI: "Hyvitys",
        SV: "Återbetalning",
        NO: "Tilbakebetaling",
    },

    "receipt-total-amount-resale": {
        EN: "Payout",
        DA: "Udbetaling",
        DE: "Auszahlung",
        NL: "Uitbetaling",
        FR: "Paiement",
        IT: "Pagamento",
        ES: "Pago",
        PT: "Pagamento",
        FI: "Maksu",
        SV: "Utbetalning",
        NO: "Utbetaling",
    },

    "receipt-header": {
        EN: "Refund summary",
        DA: "Refusionsoversigt",
        DE: "Rückerstattungsoversigt",
        NL: "Terugbetalingsoversigt",
        FR: "Résumé du remboursement",
        IT: "Riepilogo rimborso",
        ES: "Resumen de reembolso",
        PT: "Resumo do reembolso",
        FI: "Hyvityksen yhteenveto",
        SV: "Sammanfattning av återbetalning",
        NO: "Oppsummering av tilbakebetaling",
    },

    "receipt-header-resale": {
        EN: "Estimated final payout",
        DA: "Estimeret endelig udbetaling",
        DE: "Geschätzte Endzahlung",
        NL: "Geschatte einduitbetaling",
        FR: "Paiement final estimé",
        IT: "Pagamento finale stimato",
        ES: "Pago final estimado",
        PT: "Pagamento final estimado",
        FI: "Arvioitu lopullinen maksu",
        SV: "Estimerad slutlig utbetalning",
        NO: "Estimert endelig utbetaling",
    },

    "confirmation-page-total-amount.gift-card": {
        EN: "Gift card",
        DA: "Gavekort",
        DE: "Geschenkkarte",
        NL: "Cadeaubon",
        FR: "Carte cadeau",
        IT: "Carta regalo",
        ES: "Tarjeta de regalo",
        PT: "Cartão-presente",
        FI: "Lahjakortti",
        SV: "Presentkort",
        NO: "Gavekort",
    },

    "confirmation-page.total-amount.complaint-warning": {
        EN: "* Final amount may change after review",
        DA: "* Endeligt beløb kan ændres efter gennemgang",
        DE: "* Der endgültige Betrag kann sich nach Prüfung ändern",
        NL: "* Het eindbedrag kan veranderen na controle",
        FR: "* Le montant final peut changer après révision",
        IT: "* L'importo finale può cambiare dopo la revisione",
        ES: "* El monto final puede cambiar después de la revisión",
        PT: "* O valor final pode mudar após revisão",
        FI: "* Lopullinen summa voi muuttua tarkistuksen jälkeen",
        SV: "* Beloppet kan ändras efter granskning",
        NO: "* Beløpet kan endres etter gjennomgang",
    },

    "confirmation-page.total-amount.resale-info": {
        EN: "* Final amount depends on resale success",
        DA: "* Endeligt beløb afhænger af videresalgssucces",
        DE: "* Der endgültige Betrag hängt vom Erfolg des Wiederverkaufs ab",
        NL: "* Het eindbedrag hangt af van het doorverkoopsucces",
        FR: "* Le montant final dépend du succès de la revente",
        IT: "* L'importo finale dipende dal successo della rivendita",
        ES: "* El monto final depende del éxito de la reventa",
        PT: "* O valor final depende do sucesso da revenda",
        FI: "* Lopullinen summa riippuu jälleenmyynnin onnistumisesta",
        SV: "* Slutsumman beror på hur återförsäljningen går",
        NO: "* Sluttsummen avhenger av videresalgets resultat",
    },
};

export default texts;
